import dao from '../../../../dao/subsDao';

const LIST_BILLS = 'pages/generalsettings/billing/details/LIST_BILLS';
const LIST_BILLS_SUCCESS =
  'pages/generalsettings/billing/details/LIST_BILLS_SUCCESS';

const initialState = {
  bills: [],
  isLoaded: false,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LIST_BILLS:
      return {
        ...state,
        isLoaded: false,
      };
    case LIST_BILLS_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        bills: action.json,
      };
    }
    default:
      return state;
  }
};

export function listBills() {
  return dispatch => {
    dispatch({
      type: LIST_BILLS,
    });
    return dao.listBills().then(json => dispatch(listBillsSuccess(json)));
  };
}

function listBillsSuccess(json) {
  return {
    type: LIST_BILLS_SUCCESS,
    json,
  };
}
